export const usePromiseWithTimeout = () => {
  const delay = (ms = 2000) => new Promise((resolve) => setTimeout(() => resolve(true), ms));

  const getPromiseWithTimeout = <T>(promise: Promise<T>, minDuration?: number) =>
    Promise.all([promise, delay(minDuration)]);

  return {
    delay,
    getPromiseWithTimeout,
  };
};
